/*
 *@Description: 合并订单
 *@ComponentAuthor: lorry
*/
<template>
  <div class="mergeOrder">
    <el-dialog lock-scroll
               :modal-append-to-body="false"
               :append-to-body="true"
               :title="$lang('合单')"
               :visible="mergeVisible"
               custom-class="jms-dialog mergeOrder"
               :close-on-click-modal="false"
                @close="close"
               width="900px">
      <div class="overflow">
        <div class="sub-title">{{ $lang('检测到以下订单可以合并') }}</div>
        <JmsTable ref="jmsTable" :option = "listOpt"
                :data="tableList"
                :page="page"
                :tablePageVisible="false"
                :rowClassName="rowClassName"
                @selection-change="selectionChange"
                @current-change="currentChange">
        </JmsTable>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" plain @click="prevOne" :disabled="prevEditable" class="h40">{{$lang('上一个')}}</el-button>
        <el-button type="primary" :disabled="selection.length<2" :loading="keyBtn" @click="comfirmMerge" class="h40">{{$lang('合并订单')}}</el-button>
        <el-button type="primary" plain @click="nextOne" :disabled="nextEditable" class="h40">{{$lang('下一个')}}</el-button>
      </div>

    </el-dialog>
  </div>
</template>

<script>
import { RESPONSE_SUCCESS } from '@constants'
import JmsTable from '@/components/jms-widget/jms-table'
import mixin from '@/mixins/mixin.js'
import { mapGetters } from 'vuex'
import { addressPage } from '@api/module/customer'
import { orderMerge } from '@api/module/customer'

export default {
  name: 'MergeOrder',
  components: {
    JmsTable,
  },
  mixins: [mixin],
  props: {
    mergeList: {
      type: Array,
      default: function() {
        return []
      },
    },
    mergeVisible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      COM_HTTP: {
        reqList: addressPage,
      },
      pageLength: 0,
      curPage: 1,
      selection: [],
      prevEditable: true,
      nextEditable: true,
      keyBtn: false,
    }
  },
  watch: {
    mergeList: {
      handler(val) {
        if (val.length > 1) {
          this.nextEditable = false
        }
        this.pageLength = val.length
        this.tableList = val[0]
        this.isReloadList = false
      },
    },
    curPage: {
      handler(val) {
        if (val < this.pageLength && this.pageLength > 1) {
          this.nextEditable = false
        } else {
          this.nextEditable = true
        }
        if (val === 1) {
          this.prevEditable = true
        } else {
          this.prevEditable = false
        }
      },
    },
  },
  computed: {
    ...mapGetters({
      user: 'user',
    }),
    listOpt() {
      return {
        border: true,
        selection: true,
        menu: false,
        tableHeight: 420,
        currentRow: true,
        selectable: this.selectable,
        column: [
          {
            label: '订单编号',
            prop: 'id',
            width: 150,
          },
          {
            label: '寄件方',
            prop: 'senderName',
            formatter: (row, value, label, column) => {
              return `${row.senderName}/${row.senderMobilePhone}/${row.senderProvinceName}/${row.senderCityName}/${row.senderAreaName}/${row.senderDetailedAddress}`
            },
            width: 300,
          },
          {
            label: '收件方',
            prop: 'receiverName',
            formatter: (row, value, label, column) => {
              return `${row.receiverName}/${row.receiverMobilePhone}/${row.receiverProvinceName}/${row.receiverCityName}/${row.receiverAreaName}/${row.receiverDetailedAddress}`
            },
            width: 300,
          },
          {
            label: '物品类型',
            prop: 'goodsTypeName',
          },
          {
            label: '物品名称',
            prop: 'goodsName',
          },
          {
            label: '物品重量',
            prop: 'packageTotalWeight',
          },
          {
            label: '支付方式',
            prop: 'paymentModeName',
          },
        ],
      }
    },
  },
  created() {
  },
  mounted() {
  },
  methods: {
    // 行是否可被选中
    selectable(row, index) {
      return !row.isMerge
    },
    rowClassName(item, index) {
      return item.row.isMerge ? 'is_merge' : ''
    },
    // 查询方法（重置）
    async searchFun(current) {

    },
    // 当用户手动勾选全选或多选 Checkbox 时触发的事件
    selectionChange(selection) {
      this.selection = selection
    },
    // 关闭弹窗
    close() {
      this.$emit('closeMerge', this.isReloadList)
      this.curPage = 1
    },
    // 上一个
    prevOne() {
      if (this.curPage === 1) return
      this.curPage -= 1
      this.tableList = this.mergeList[this.curPage - 1]
    },
    // 下一个
    nextOne() {
      if (this.curPage === this.pageLength) return
      this.curPage += 1
      this.tableList = this.mergeList[this.curPage - 1]
    },
    // 合并订单
    async comfirmMerge() {
      const param = this.selection.map(item => item.id)
      this.keyBtn = true
      const { code, data, msg } = await orderMerge(param)
      this.keyBtn = false
      if (code === RESPONSE_SUCCESS || code === 121035006) {
        data.isMerge = true
        data.id = '已合单'
        let arr = [...this.tableList].filter(x => [...this.selection].every(y => y.id !== x.id))
        arr.unshift(data)
        this.tableList = JSON.parse(JSON.stringify(arr))
        this.selection = []
        arr = []
        this.mergeList[this.curPage - 1] = this.tableList
        const msg1 = code === 121035006 ? msg : '合并成功'
        this.$message.success(msg1)
        this.isReloadList = true
      } else {
        this.$message.error(msg)
      }
    },
  },
}
</script>

<style scoped lang="scss" scoped>
.form-title{
  font-size: 16px;
  font-weight: bold;
  i{
    margin-right: 7px;
  }
}
.sub-title{
  padding-bottom: 10px;
  font-size: 14px;
  color: #333;
}

</style>
